import { useCallback } from 'react';

import { type ActionHandler } from '@fhs/page-builder';
import { openServiceModeDialog } from '@fhs/routing';
import {
  CustomEventNames,
  EventTypes,
  useCRMEventsContext,
} from '@fhs-legacy/frontend/src/state/crm-events';

// action handler for loyalty homepage only.
export function useActionHandler(): ActionHandler {
  const { logRBIEvent } = useCRMEventsContext();

  const handleAction: ActionHandler = useCallback(
    action => {
      switch (action.action) {
        case 'open-do-not-sell-or-share-personal-information-modal': {
          logRBIEvent({
            name: CustomEventNames.CLICK_EVENT,
            type: EventTypes.Navigation,
            attributes: { action: { action: action.action } },
          });

          window?.OneTrust?.ToggleInfoDisplay?.();

          return;
        }

        case 'open-href': {
          logRBIEvent({
            name: CustomEventNames.CLICK_EVENT,
            type: EventTypes.Navigation,
            attributes: { action: { href: action.href, action: action.action } },
          });

          return;
        }

        case 'start-order-flow': {
          logRBIEvent({
            name: CustomEventNames.CLICK_EVENT,
            type: EventTypes.Navigation,
            attributes: {
              action: {
                startOrderFlowServiceMode: action.startOrderFlowServiceMode,
                action: action.action,
              },
            },
          });

          if (action.startOrderFlowServiceMode === 'ask') {
            openServiceModeDialog();
          }

          return;
        }

        default: {
          logRBIEvent({
            name: CustomEventNames.CLICK_EVENT,
            type: EventTypes.Navigation,
            attributes: {
              action,
            },
          });

          return;
        }
      }
    },
    [logRBIEvent]
  );

  return handleAction;
}
